function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _classCallCheck = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _createClass = unwrapExports(createClass);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _assertThisInitialized = unwrapExports(assertThisInitialized);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inherits = unwrapExports(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _typeof = unwrapExports(_typeof_1);

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _getPrototypeOf = unwrapExports(getPrototypeOf);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

var classApplyDescriptorGet = createCommonjsModule(function (module) {
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

module.exports = _classApplyDescriptorGet, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(classApplyDescriptorGet);

var classExtractFieldDescriptor = createCommonjsModule(function (module) {
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }

  return privateMap.get(receiver);
}

module.exports = _classExtractFieldDescriptor, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(classExtractFieldDescriptor);

var classPrivateFieldGet = createCommonjsModule(function (module) {
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = classExtractFieldDescriptor(receiver, privateMap, "get");
  return classApplyDescriptorGet(receiver, descriptor);
}

module.exports = _classPrivateFieldGet, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _classPrivateFieldGet = unwrapExports(classPrivateFieldGet);

/**
 * The {{#crossLink "BaseObject"}}{{/crossLink}} class is an abstract class that provides common properties and functionality for all StructureJS classes.
 *
 *  @author Robert S. (www.codeBelt.com)
 */
var BaseObject = /*#__PURE__*/function () {
  function BaseObject() {
    _classCallCheck(this, BaseObject);
  }

  _createClass(BaseObject, [{
    key: "destroy",
    value:
    /**
     * The purpose of the destroy method is to make an object ready for garbage collection. This
     * should be thought of as a one way function. Once destroy is called no further methods should be
     * called on the object or properties accessed. It is the responsibility of those who implement this
     * function to stop all running Timers, all running Sounds, and take any other steps necessary to make an
     * object eligible for garbage collection.
     *
     * By default, the destroy method will null out all properties of the class automatically. You should call destroy
     * on other objects before calling the super.
     *
     * @example
     *     destroy() {
     *          this.disable();
     *
     *          this._childInstance.destroy();
     *
     *          super.destroy();
     *     }
     */
    function destroy() {
      var _this = this;

      Object.keys(this).forEach(function (propertyName) {
        return _this[propertyName] = null;
      });
    }
    /**
     * Gets the class/model name.
     */

  }, {
    key: "getClassName",
    value: function getClassName() {
      return this.constructor.name;
    }
  }]);

  return BaseObject;
}();

var ConversionTypeEnum;

(function (ConversionTypeEnum) {
  ConversionTypeEnum["Boolean"] = "boolean";
  ConversionTypeEnum["Float"] = "float";
  ConversionTypeEnum["JSON"] = "json";
  ConversionTypeEnum["Number"] = "number";
  ConversionTypeEnum["String"] = "string";
})(ConversionTypeEnum || (ConversionTypeEnum = {}));

/**
 * A Utility class that has several static methods to assist in development.
 *
 * @author Robert S. (www.codeBelt.com)
 * @static
 */
var Util = /*#__PURE__*/function () {
  function Util() {
    _classCallCheck(this, Util);
  }

  _createClass(Util, null, [{
    key: "clone",
    value:
    /**
     * Makes a clone of an object.
     *
     * @param src {Object} The object you to clone.
     * @param renamePropertyName {(keyName: string) => string} Optional function to rename property names
     * @returns {any} Returns a clone object of the one passed in.
     * @example
     *      let cloneOfObject = Util.clone(obj);
     */
    function clone(src, renamePropertyName) {
      if (src === null || typeof src === 'undefined' || _typeof(src) !== 'object') {
        return src;
      }

      if (src instanceof Date) {
        return new Date(src.getTime());
      }

      if (src instanceof RegExp) {
        return new RegExp(src);
      }

      if (src instanceof Array) {
        return src.map(function (item) {
          return Util.clone(item, renamePropertyName);
        });
      }

      if (src instanceof Object) {
        var objCopy = {};
        Object.keys(src).forEach(function (keyName) {
          var name = renamePropertyName ? renamePropertyName(keyName) : keyName;
          objCopy[name] = Util.clone(src[keyName], renamePropertyName);
        });
        return objCopy;
      }

      throw new Error("Unable to copy. ".concat(src, " isn't supported."));
    }
    /**
     * Converts a string or number to a boolean.
     * @example
     *      Util.toBoolean("FALSE");
     *      // false
     *
     *      Util.toBoolean("off");
     *      // false
     *
     *      Util.toBoolean(0);
     *      // false
     *
     *      Util.toBoolean(undefined);
     *      // false
     */

  }, {
    key: "toBoolean",
    value: function toBoolean(value) {
      var normalized = typeof value === 'string' ? value.toLowerCase() : value;
      return !(normalized == null || normalized <= 0 || normalized === 'false' || normalized === 'off');
    }
  }, {
    key: "validConversionOptionNames",
    value: function validConversionOptionNames(data) {
      var conversionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Object.keys(conversionOptions).forEach(function (conversionPropertyName) {
        if (!data.hasOwnProperty(conversionPropertyName)) {
          throw new SyntaxError("Conversion property name \"".concat(conversionPropertyName, "\" does not match a property name on the model."));
        }
      });
    }
  }, {
    key: "convertDataToConversionType",
    value: function convertDataToConversionType(propertyData, conversionType) {
      switch (conversionType) {
        case ConversionTypeEnum.Boolean:
          return Util.toBoolean(propertyData);

        case ConversionTypeEnum.Float:
          return propertyData === null ? null : parseFloat(propertyData);

        case ConversionTypeEnum.Number:
          return propertyData === null ? null : parseInt(propertyData, 10);

        case ConversionTypeEnum.String:
          if (Util.isObject(propertyData)) {
            return JSON.stringify(propertyData);
          }

          return propertyData === null ? null : String(propertyData);

        case ConversionTypeEnum.JSON:
          try {
            return JSON.parse(propertyData);
          } catch (error) {
            // Don't throw or console.log errors because it's by design to return the data on error.
            // For example the first time the model is created it needs to parse the data but if the
            // models update method is called we want to keep the data the same.
            return propertyData;
          }

        default:
          return propertyData;
      }
    }
    /**
     * Check the data is an object with properties.
     */

  }, {
    key: "isObjectWithProperties",
    value: function isObjectWithProperties(data) {
      return Util.isObject(data) && Object.keys(data).length > 0;
    }
    /**
     * Check if the data is an object.
     */

  }, {
    key: "isObject",
    value: function isObject(data) {
      return Boolean(data) && Array.isArray(data) === false && _typeof(data) === 'object';
    }
  }]);

  return Util;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

var _sjsOptions = /*#__PURE__*/new WeakMap();

/**
 * BaseModel is a design pattern used to transfer data between software application subsystems.
 *
 * Note: If the data doesn't match the property names you can set the value manually after update super method has been called.
 * Also in the class you inherit BaseModel from you can override the update method to handle the data how you want.
 *
 * @param [data] {any} Provide a way to update the base model upon initialization.
 * @param [opts] {{ expand:boolean }} Options for the base model.
 * @author Robert S. (www.codeBelt.com)
 * @example
 *      // Example how to extend the BaseModel class.
 *      let data = {
 *              make: 'Tesla',
 *              model: 'Model S',
 *              YeAr: 2014,
 *              feature: {
 *                  abs: true,
 *                  airbags: true
 *              }
 *      }
 *      let carModel = new CarModel(data);
 *
 *
 *      // Example how to extend the BaseModel class.
 *      class CarModel extends BaseModel {
 *
 *          // You need to have properties so the data will get assigned.
 *          // If not the data will not get assigned to the model.
 *          make = null;
 *          model = null;
 *          year = null;
 *          allWheel = false; // Set a default value
 *
 *          // You can assign BaseModel to a property which will
 *          // automatically created it and pass the data to it.
 *          feature = FeatureModel
 *
 *          // If you have an array of data and want them assign to a BaseModel.
 *          feature = [FeatureModel];
 *
 *          constructor(data = {}, opts = {}) {
 *              super(opts);
 *
 *              if (data) {
 *                  this.update(data);
 *              }
 *          }
 *
 *          // @overridden BaseModel.update
 *          update(data) {
 *              super.update(data);
 *
 *              // If the data doesn't match the property name.
 *              // You can set the value(s) manually after the update super method has been called.
 *              this.year = data.YeAr;
 *          }
 *      }
 */
var BaseModel = /*#__PURE__*/function (_BaseObject) {
  _inherits(BaseModel, _BaseObject);

  var _super = _createSuper(BaseModel);

  /**
   * This property helps distinguish a BaseModel from other functions.
   */
  function BaseModel() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BaseModel);

    _this = _super.call(this);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _sjsOptions, {
      writable: true,
      value: {
        expand: false
      }
    });

    _classPrivateFieldGet(_assertThisInitialized(_this), _sjsOptions).expand = opts.expand === true;
    return _this;
  }
  /**
   * Provide a way to update the BaseModel.
   *
   * @example
   *     // Example of updating some data:
   *     carModel.update({ year: 2015, allWheel: true});
   *
   *     // Of course you can also do it the following way:
   *     carModel.year = 2015;
   *     carModel.allWheel = false;
   */


  _createClass(BaseModel, [{
    key: "update",
    value: function update() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var conversionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var dataToUse = this._isObject(data, true) ? data : {};
      Util.validConversionOptionNames(this, conversionOptions);
      Object.keys(this).forEach(function (propertyName) {
        var currentPropertyData = _this2[propertyName];
        var passedInDataForProperty = dataToUse[propertyName];

        if (Boolean(conversionOptions[propertyName])) {
          var conversionType = conversionOptions[propertyName];
          passedInDataForProperty = Util.convertDataToConversionType(passedInDataForProperty, conversionType);
        }

        _this2[propertyName] = _this2._getPropertyData(currentPropertyData, passedInDataForProperty);
      });
      return this;
    }
    /**
     * Converts the BaseModel data into a JSON object.
     *
     * @example
     *     const obj = carModel.toJSON();
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return Util.clone(this);
    }
    /**
     * Converts a BaseModel to a JSON string,
     *
     *  @example
     *     const str = carModel.toJSONString();
     */

  }, {
    key: "toJSONString",
    value: function toJSONString() {
      return JSON.stringify(this.toJSON());
    }
    /**
     * Converts the string json data into an Object and calls the {{#crossLink "BaseModel/update:method"}}{{/crossLink}} method with the converted Object.
     *
     * @example
     *      const str = '{"make":"Tesla","model":"Model S","year":2014}'
     *      const carModel = new CarModel();
     *      carModel.fromJSON(str);
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var parsedData = JSON.parse(json);
      this.update(parsedData);
      return this;
    }
    /**
     * Create a clone/copy of the BaseModel.
     *
     * @example
     *     const clone = carModel.clone();
     *
     *     const clone = carModel.clone<SomeModel>();
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this);
    }
    /**
     * Adds the updateData to the property
     */

  }, {
    key: "_getPropertyData",
    value: function _getPropertyData(currentPropertyData, passedInDataForProperty) {
      var _this3 = this;

      if (Array.isArray(currentPropertyData) === true) {
        var fistItemInArray = currentPropertyData[0];

        var isBaseModelObject = this._isBaseModelObject(fistItemInArray);

        var isBaseModelClass = this._isBaseModelClass(fistItemInArray);

        if (passedInDataForProperty == null && isBaseModelClass) {
          return [];
        }

        if (passedInDataForProperty == null) {
          return currentPropertyData;
        }

        var arrayData = Array.isArray(passedInDataForProperty) === false ? [passedInDataForProperty] : passedInDataForProperty;

        if (isBaseModelClass) {
          return arrayData.map(function (json) {
            return new fistItemInArray(json, _classPrivateFieldGet(_this3, _sjsOptions));
          });
        }

        if (isBaseModelObject) {
          return arrayData.map(function (json) {
            return new fistItemInArray.constructor(json, _classPrivateFieldGet(_this3, _sjsOptions));
          });
        }

        return arrayData;
      }

      return passedInDataForProperty == null ? this._updateData(currentPropertyData, null) : this._updateData(currentPropertyData, passedInDataForProperty);
    }
  }, {
    key: "_updateData",
    value: function _updateData(currentPropertyData, passedInDataForProperty) {
      var isBaseModelObject = this._isBaseModelObject(currentPropertyData);

      var isBaseModelClass = this._isBaseModelClass(currentPropertyData);

      var isPassedInDataAnObjectWithProperties = Util.isObjectWithProperties(passedInDataForProperty);

      if (isBaseModelObject && isPassedInDataAnObjectWithProperties) {
        // Call the update method on th BaseModel object and give it the passed in data.
        var baseModel = currentPropertyData;
        baseModel.update(passedInDataForProperty);
        return baseModel;
      }

      if (isBaseModelClass && (isPassedInDataAnObjectWithProperties || _classPrivateFieldGet(this, _sjsOptions).expand === true)) {
        // If data is passed in or the expand option is set to true then create the BaseModel.
        // Give the constructor the passed in data or an empty object if expand is true.
        var obj = isPassedInDataAnObjectWithProperties ? passedInDataForProperty : {};
        return new currentPropertyData(obj, _classPrivateFieldGet(this, _sjsOptions));
      } else if (isBaseModelClass) {
        // Don't create the BaseModel if there is no data passed in. Return null to be assigned to the property.
        return null;
      } // If there is no data passed in then return the data that is currently on the property, so it stays the same.


      return passedInDataForProperty != null ? passedInDataForProperty : currentPropertyData;
    }
    /**
     * Check the currentPropertyData to see if it is a BaseModel Class and not instantiated.
     */

  }, {
    key: "_isBaseModelClass",
    value: function _isBaseModelClass(currentPropertyData) {
      return typeof currentPropertyData === 'function' && currentPropertyData.IS_BASE_MODEL;
    }
    /**
     * Check the currentPropertyData to see if it is an instantiated version of the BaseModel.
     */

  }, {
    key: "_isBaseModelObject",
    value: function _isBaseModelObject(currentPropertyData) {
      return currentPropertyData instanceof BaseModel;
    }
    /**
     * Check if the data is an object.
     */

  }, {
    key: "_isObject",
    value: function _isObject(data) {
      var consoleError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isObject = Util.isObject(data);

      if (!isObject && consoleError) {
        console.error("Something is wrong! ".concat(this.getClassName(), " only allows Objects but \"").concat(data, "\" was passed in."));
      }

      return isObject;
    }
  }]);

  return BaseModel;
}(BaseObject);

_defineProperty(BaseModel, "IS_BASE_MODEL", true);

export { BaseModel, ConversionTypeEnum, Util };
//# sourceMappingURL=index.esm.js.map
